import { DOServer } from "./config";

export const pdfUrl = (file) => {
  if (!file || !file.name || !file.uuid) return "#";
  return `${DOServer}${file.uuid}/${file.name}`;
};
